import { RootState } from '@app/redux/root-reducer';

export const selectInternState = (store: RootState) => store.internsReducer.interns;
export const selectUpdateInternStatusState = (store: RootState) =>
  store.internsReducer.updateInternStatus;
export const selectInternDetailsState = (store: RootState) => store.internsReducer.internDetails;
export const selectInternTransactionState = (store: RootState) =>
  store.internsReducer.getTransaction;
export const updateInternState = (store: RootState) => store.internsReducer.updateIntern;
export const selectPromoteAsEmployeeState = (store: RootState) =>
  store.internsReducer.promoteAsEmployee;
